export default "__VITE_ASSET__DYWCF9KZ__";